import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TableHeaderDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getTableStickyZIndexes
} from "../../stylesheet";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    sticky: {
        ...webStyle({
            position: "sticky",
            top: 0
        })
    },
    container: {
        alignSelf: "stretch"
    }
});

export const useStyles = ({
    background,
    isSticky,
    layers
}: TableHeaderDynamicStyleType) => {
    const styles = {
        container: {} as Mutable<ViewStyle>
    };

    if(isSticky) {
        Object.assign(styles.container, {
            backgroundColor: background,
            ...webStyle({
                zIndex: getTableStickyZIndexes({
                    layers
                }).header
            })
        });
    }

    return styles;
};
export default stylesheet;
